import Modal from "components/atoms/modal";
import { TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClose: () => void;
}

const ModalWelcomeBeta = ({ onClose }: Props) => {
  const handleClick = () => {
    window.location.href = "https://macodi.co.kr/";
    onClose();
  };

  return (
    <Modal.Container className="min-w-[312px] p-10 rounded-16 text-center">
      <TextSm className="text-black-100% mb-5">
        사전등록이 완료되었습니다.
        <br />
        신청해 주셔서 감사합니다.
        <br />
        <span className="text-xs text-black-60%">
          베타서비스는 12월 5일에 시작합니다.
        </span>
      </TextSm>
      <Btn.Blue onClick={handleClick} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalWelcomeBeta;
